/**
 * Bitway Earn staking-vault read surface (BNB chain 56 — the Absolute
 * Return and Core Alpha multi-token vaults; see BITWAY.md at the repo
 * root).
 *
 * One vault contract serves several supported tokens; the LP tokens
 * (bwUSDT, BTWUSDT, …) are bare ERC-20s — `asset()`, `totalAssets()` and
 * the one-arg `convertToAssets()` all revert. Every read is a call on the
 * PARENT vault with the underlying token as an argument, and the rate
 * getter is the TWO-ARG `convertToAssets(uint256, address token)`.
 *
 * Deliberately not read (no getter exists): `penaltyRate` (private —
 * slot 12; 50 bps on Absolute Return, 0 on Core Alpha, verified via raw
 * storage 2026-08-19) and the inverted-name `flashNotEnable` /
 * `cancelNotEnable` flags (packed into the withdrawVault slot; both
 * ENABLED live). The reader pins the penalty per vault; a change is an
 * admin action on an unverified contract, re-checked by the live row
 * test.
 */
export const BitwayVaultReadAbi = [
  {
    name: 'convertToAssets',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256' }, { type: 'address', name: 'token' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'getTVL',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: 'token' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'getContractBalance',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: 'token' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'getCurrentRewardRate',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: 'token' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'WAITING_TIME',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
